import styled from "styled-components";
import { cardHeaderStyles } from "../../../theme/mixins";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import zIndexTypes from "../../../theme/zIndexTypes";

export const StyledModalBackdrop = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndexTypes.modal};
  background-color: ${({ theme }) => theme.colors.backdropColor};
  opacity: 0.6;
`;

StyledModalBackdrop.displayName = "StyledModalBackdrop";

export const StyledModalWrapper = styled.div`
  overflow: hidden auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: ${zIndexTypes.modal};
`;

StyledModalWrapper.displayName = "StyledModalWrapper";

type StyledModalContentType = {
  maxWidth?: string;
};

export const StyledModalContent = styled.div<StyledModalContentType>`
  background: ${({ theme }) => theme.colors.white};
  position: relative;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : "600px")};
  min-height: 150px;
  border-radius: ${({ theme }) => theme.borderRadius};
  margin: 2rem auto;
  padding: 1rem;
  z-index: ${zIndexTypes.modal};

  #close-modal-button {
    position: absolute;
    top: 5px;
    right: 20px;
    font-size: ${({ theme }) => theme.fontSize.icon.desktop};
  }

  ${mediaMaxWidth.tablet} {
    margin: 10px auto;
    width: calc(100vw - 40px);
  }

  ${mediaMaxWidth.phone} {
    margin: 10px;
    width: calc(100vw - 20px);

    #close-modal-button {
      top: 10px;
      font-size: ${({ theme }) => theme.fontSize.icon.mobile};
    }
  }
`;

StyledModalContent.displayName = "StyledModalContent";

export const StyledModalTitle = styled.h3`
  ${cardHeaderStyles};
  margin: 0 0 10px 0;
`;

StyledModalTitle.displayName = "StyledModalTitle";
